import React, { useEffect, useState } from "react";

// Components
import SectionTitle from "../SectionTitle";
import StatCard from "./components/StatCard";
import CardSkeleton from "./components/CardSkeleton";
import RangeFilter from "../../../../../common/components/RangeFilter";

// stat icons
const totalSalesIcon = `${EASYCOMMERCE.assets}admin/img/dashboard/sales.png`;
const totalOrdersIcon = `${EASYCOMMERCE.assets}admin/img/dashboard/orders.png`;
const productsSoldIcon = `${EASYCOMMERCE.assets}admin/img/dashboard/sold.png`;
const newCustomersIcon = `${EASYCOMMERCE.assets}admin/img/dashboard/customers.png`;
const refundsIcon = `${EASYCOMMERCE.assets}admin/img/dashboard/refunds.png`;
const abandonedCart = `${EASYCOMMERCE.assets}admin/img/dashboard/abandoned-cart.png`;
const productIcon = `${EASYCOMMERCE.assets}admin/img/dashboard/products.png`;
const revenueIcon = `${EASYCOMMERCE.assets}admin/img/dashboard/revenue.png`;

// Stats static data
const statsData = [
    {
        icon: totalOrdersIcon,
        cardBg: "bg-[#DBEAFE]",
        label: "Orders",
        value: "",
    },
    {
        icon: totalSalesIcon,
        cardBg: "bg-[#FFEDD4]",
        label: "Sales",
        value: "",
    },
    {
        icon:  refundsIcon,
        cardBg: "bg-[#FCE7F3]",
        label: "Refunds",
        value: "",
    },
    {
        icon: revenueIcon,
        cardBg: "bg-[#D9F9E4]",
        label: "Revenue",
        value: "",
    },
    {
        icon:  productsSoldIcon,
        cardBg: "bg-[#FFE9E0]",
        label: "Items Sold",
        value: "",
    },
    {
        icon: newCustomersIcon,
        cardBg: "bg-[#E1F3E1]",
        label: "Customers",
        value: "",
    },
    {
        icon: productIcon,
        cardBg: "bg-[#E0E7FF]",
        label: "Products",
        value: "",
    },
    {
        icon: abandonedCart,
        cardBg: "bg-[#FFE4E6]",
        label: "Abandoned Carts",
        value: "",
    },
];

const Stats = () => {
    const [range, setRange] = useState("this-month");
    const [customRange, setCustomRange] = useState({
        from: "",
        to: "",
    });
    const [stats, setStats] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [filterLabel, setFilterLabel] = useState("This Month");

    const handleRange = (value) => {
        setRange(value);
        setCustomRange({ from: "", to: "" });
    };

    const handleCustomRange = (key, value) => {
        setRange(null);
        setCustomRange({ ...customRange, [key]: value });
    };

    const fetchStats = (url) => {
        fetch(url,{
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            }
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success && data.data?.stats) {
                    const statsLabels = Object.keys(data.data.stats);
                    const statsValues = Object.values(data.data.stats);

                    const updatedStats = statsData.map((item, index) => ({
                        ...item,
                        label: statsLabels[index],
                        value: statsValues[index],
                    }));

                    setStats(updatedStats);
                }

                setIsLoading(false);
            });
    };

    useEffect(() => {
        let url = `${EASYCOMMERCE.rest_base}/dashboard/stats`;

        if (range && !customRange.from && !customRange.to) {
            url += `?range=${range}`;

            fetchStats(url);
        } else if (!range && customRange.from && customRange.to) {
            const queryString = new URLSearchParams({
                from: customRange.from,
                to: customRange.to,
            }).toString();

            url += `?${queryString}`;

            fetchStats(url);
        }
    }, [range, customRange.from, customRange.to]);

    return (
        <div className="col-span-12 min-[1400px]:col-span-8 bg-white rounded-xl">
            <div className="flex flex-col gap-6">
                <div className="flex items-center justify-between pr-6 border-b border-ec-table-stock">
                    <SectionTitle title="Stats" />

                    {!isLoading && (
                        <RangeFilter
                            range={range}
                            customRange={customRange}
                            filterLabel={filterLabel}
                            handleRange={handleRange}
                            handleCustomRange={handleCustomRange}
                            handleFilterLabel={(str) => setFilterLabel(str)}
                        />
                    )}
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[24px] max-[1600px]:gap-4 px-6 pb-6">
                    {!isLoading ? (
                        
                        stats.length > 0 && (
                            <>
                                {stats.map((stat, index) => (
                                    <StatCard
                                        key={index}
                                        icon={stat.icon}
                                        cardBg={stat.cardBg}
                                        label={statsData[index].label}
                                        value={stat.value}
                                    />
                                ))}
                            </>
                        )
                    ) : (
                        <CardSkeleton />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Stats;
